import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import {
  REQUIRED,
  SelectionField,
  SingleFileField,
  TextField,
} from "../../Components/constants/field";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Common/Loader";
import * as Yup from "yup";
import {
  findByIdTourFacilities,
  insertTourFacilities,
  updateTourFacilities,
} from "../../slices/tourfacilities/thunk";

const CreateTourFacility = () => {
  const history = useNavigate();
  const { ID } = useParams();
  const dispatch = useDispatch();
  const {
    loading,
    tourfacilityDetail: { form },
  } = useSelector((state) => state.TourFacility);
  useEffect(() => {
    if (ID) {
      let params = {
        ID: ID,
      };
      dispatch(findByIdTourFacilities(params));
    }
  }, [ID]);

  const handleSubmit = (values) => {
    let tourF = new FormData();

    Object.keys(values).map((key) => {
      if (key === "FacilityImage") {
        tourF.append(key, values[key][0]);
      } else {
        tourF.append(key, values[key]);
      }
    });


    if (ID) {
      if (typeof tourF.get("FacilityImage") === "string") {
        tourF.delete("FacilityImage");
        tourF.append("FacilityImage", "");
      }
      tourF.delete("UpdatedBy");
      tourF.append("ID", ID);
      dispatch(updateTourFacilities(tourF)).then((res) => {
        if (res.payload && res.payload.Status === 200) {
          history("/tourfacility");
        }
      });
    } else {
      tourF.delete("ID");
      dispatch(insertTourFacilities(tourF)).then((res) => {
        if (res.payload && res.payload.Status === 200) {
          history("/tourfacility");
        }
      });
    }
  };
  if (loading) {
    return <Loader />;
  }

  return (
    <div className="page-content">
      <Container fluid>
        <ToastContainer />
        <BreadCrumb title="Tour Facility" pageTitle="Tour Facility" />
        <Row>
          <Col xl={12}>
            <Card color="dark" outline>
              <CardHeader className="bg-light">
                <Row className="align-items-center">
                  <Col md="11">
                    <h4 className="card-title mb-0">
                      {ID ? "Update Tour Facility" : " Create Tour Facility"}
                    </h4>
                  </Col>
                  <Col md="1">
                    <Link to="/tourfacility">
                      <Button color="primary" block>
                        Back
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg={12}>
                    <Formik
                      enableReinitialize={true}
                      initialValues={form}
                      validationSchema={Yup.object({
                        Name: Yup.string().nullable(true).required(REQUIRED),
                      })}
                      onSubmit={handleSubmit}
                    >
                      {() => {
                        return (
                          <Form noValidate autoComplete="off">
                            <div>
                              <Row>
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="Name"
                                    >
                                      Name:
                                    </Label>
                                    <Field
                                      name="Name"
                                      className="form-control"
                                      id="Name"
                                      placeholder="Enter Name"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="IsActive"
                                    >
                                      Status
                                    </Label>
                                    <Field
                                      name="IsActive"
                                      id="IsActive"
                                      options={[
                                        {
                                          label: "Active",
                                          value: true,
                                        },
                                        {
                                          label: "Inactive",
                                          value: false,
                                        },
                                      ]}
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="FacilityImage"
                                    >
                                      Facility Image:
                                    </Label>
                                    <Field
                                      type="file"
                                      name="FacilityImage"
                                      className="form-control"
                                      id="FacilityImage"
                                      maxFiles={1}
                                      component={SingleFileField}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mt-2">
                                <Col lg={12}>
                                  <hr></hr>
                                </Col>
                                <Col md="12" className="text-end">
                                  <Button type="submit" className="success">
                                    Save
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CreateTourFacility;
